export default __webpack_public_path__ + "static/media/logo.183ee2f0.png";